export const getTwitterUrl = twitterHandle => {
  return `https://twitter.com/${twitterHandle}`
}

export const getInstagramUrl = instagramHandle => {
  return `https://instagram.com/${instagramHandle}`
}
